export const companyDetailsCostants = {
    GETCOMPANTYDETAILS_REQUEST: "GETCOMPANTYDETAILS_REQUEST",
    GETCOMPANTYDETAILS_SUCCESS: "GETCOMPANTYDETAILS_SUCCESS",
    GETCOMPANTYDETAILS_FAILURE: "GETCOMPANTYDETAILS_FAILURE",
    SENDMAIL_REQUEST: "SEND_MAIL_REQUEST",
    SENDMAIL_SUCCESS: "SEND_MAIL_SUCCESS",
    SENDMAIL_FAILURE: "SEND_MAIL_FAILURE"
}